
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import CrossIconNew from "@/components/icons/CrossIconNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import moment from "moment";

@Component({
  components: {
    ModalFullScreen,
    CrossIconNew,
    UiButton,
  },
})
export default class InvoiceDashboard extends Vue {
  @Prop({ type: Array, required: true }) readonly message!: object[];
  @Prop({ type: String, required: true }) readonly taskName!: string;

  headers = [
    { text: "Date", value: "date", width: "18%" },
    { text: "Notes", value: "notes", width: "67%" },
    { text: "Hours", value: "hours", width: "15%" },
  ];

  formatedcalculateTotalHours(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours}h ${minutes}m`;
  }
  formatDate(dateString) {
    return moment(dateString).format("MMM D, YYYY");
  }

}
